// extracted by mini-css-extract-plugin
export default {"form":"style_form__t0wsF","errorText":"style_errorText__uto6x","submit":"style_submit__rfP0H","inputLabel":"style_inputLabel__8JjCy"};